<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1011 18.4051L19.4183 16.7037C19.0258 16.4606 18.524 16.7479 18.524 17.2119V18.0294L5.39357 18.0295V15.5989L3.64862 16.5711V18.9133C3.64862 19.3994 4.04115 19.7971 4.521 19.7971H18.5239L18.5241 20.6148C18.5241 21.0789 19.0257 21.366 19.4184 21.1229L22.1011 19.4215C22.45 19.1786 22.45 18.6482 22.1011 18.4051L22.1011 18.4051Z"
      :fill="fillColor"
    />
    <path
      d="M8.20722 15.3337C8.38173 15.5325 8.59974 15.621 8.8616 15.621H8.92702C9.18871 15.599 9.45053 15.4663 9.5814 15.2234L12.6786 10.4506L14.9906 12.7044C15.1869 12.8812 15.4487 12.9695 15.7104 12.9475C15.9721 12.9033 16.212 12.7487 16.3428 12.5276L19.9635 6.3186C20.2035 5.89873 20.0726 5.36854 19.6582 5.10327C19.2437 4.8602 18.7204 4.99276 18.4585 5.41261L15.405 10.6494L13.1367 8.46184C12.9404 8.28505 12.7005 8.19674 12.4387 8.21878C12.177 8.24082 11.9588 8.39557 11.8062 8.61643L8.75269 13.3229L7.13861 11.4669C6.87692 11.1575 6.41883 11.0692 6.06981 11.2901L5.3937 11.6657V6.69406H6.22257C6.68069 6.69406 6.96412 6.18589 6.72419 5.78808L5.00102 3.07029C4.78284 2.69467 4.23754 2.69467 4.01954 3.07029L2.34018 5.78808C2.10025 6.18573 2.3837 6.69406 2.8418 6.69406H3.64879V12.6379L2.07837 13.5217C1.66391 13.7648 1.51131 14.2952 1.75126 14.7148C1.99119 15.1347 2.51474 15.2893 2.929 15.0462L6.28787 13.1459L8.20722 15.3337Z"
      :fill="fillColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fillColor: {
      type: String,
      required: false,
      default: 'black',
    },
    strokeColor: {
      type: String,
      required: false,
      default: 'black',
    },
  },

  setup({}, { emit }) {},
})
</script>

<style scoped></style>
